import { OFFER_DEMAND_STATUS } from '../constants';

export default {
  entities: {
    offerDemand: {
      statusText: {
        [OFFER_DEMAND_STATUS.new]: 'Новый',
        [OFFER_DEMAND_STATUS.processing]: 'Рассматривается',
        [OFFER_DEMAND_STATUS.to_correct]: 'На исправлении',
        [OFFER_DEMAND_STATUS.to_moderation]: 'На модерации',
        [OFFER_DEMAND_STATUS.approved]: 'Одобрено',
        [OFFER_DEMAND_STATUS.rejected]: 'Отказано',
      },
      modelSeries: {
        title: 'Введите бренд товара, модель, серия и цвет',
        brandLabel: 'Бренд',
        modelLabel: 'Модель',
        seriesLabel: 'Серия',
        colorLabel: 'Цвет',
        anotherBrand: 'Другое',
        empty: 'Пусто',
      },
      characteristics: {
        valueInRu: 'Значение на русском',
        valueInUz: 'Значение на узбекском',
        empty: 'Пусто',
      },
      videos: {
        offerVideo: 'Видео о товаре',
        uzLink: 'URL-ссылка от видео на узбекском',
        ruLink: 'URL-ссылка от видео на русском ',
        empty: 'Пусто',
      },
      descriptions: {
        title: 'Описание товара',
        enterDescription: 'Введите описание',
        ru: 'На русском',
        uz: 'На узбекском',
      },
      images: {
        offerImage: 'Фото товара',
        mainImage: 'Основное',
        additionalImages: 'Дополнительные',
      },
      empty: 'Пусто',
    },
  },
};
